import React from 'react'

import about from '../assets/images/phone/half-2.png'

export default function AboutTwo() {
  return (
        <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
            <div className="lg:col-span-5 md:col-span-6 md:order-2 order-1">
                <div className="pt-6 px-6 rounded-2xl bg-red-500/5 dark:bg-red-500/10 shadow shadow-red-500/20">
                    <img src={about} alt=""/>
                </div>
            </div>

            <div className="lg:col-span-7 md:col-span-6 md:order-1 order-2">
                <div className="lg:me-10">
                    <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Tu Cuenta Club333</h6>
                    <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Todo tu perfil y saldos<br/> en un solo lugar</h4>
                    <p className="text-slate-400 max-w-xl">Disfruta una experiencia más segura y práctica administrando tu cuenta directamente desde la app Club333.</p>

                    <ul className="list-none text-slate-400 mt-6">
                        <li className="mb-1 flex"><i className="mdi mdi-check text-red-500 text-xl me-2"></i> Consulta tus saldos al instante. </li>
                        <li className="mb-1 flex ms-0"><i className="mdi mdi-check text-red-500 text-xl me-2"></i> Realiza depósitos seguros mediante SPEI.</li>
                        <li className="mb-1 flex ms-0"><i className="mdi mdi-check text-red-500 text-xl me-2"></i> Administra tu perfil desde cualquier lugar.</li>
                    </ul>

                </div>
            </div>
        </div>
  )
}
